module.exports = [{
      plugin: require('../node_modules/@ifp/gatsby-theme-shared/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
